import { cva, type VariantProps } from "cva";

export const tagStyles = cva({
  base: ["inline-flex items-center justify-center uppercase", "whitespace-nowrap"],
  variants: {
    size: {
      xs: "px-6 h-24 text-ginto-12 font-bold leading-130 font-ginto rounded-4xs",
      sm: "px-14 h-28 text-ginto-12 font-regular leading-130 font-ginto rounded-2xs border-2 border-content-primary",
      md: "px-20 h-50 text-ginto-13 font-bold leading-110 tracking-tight font-melun rounded-xs border-2 border-content-primary",
      lg: "px-24 h-63 text-ginto-16 font-bold leading-110 tracking-tight font-melun rounded-xs border-2 border-content-primary",
    },
    color: {
      yellow: "bg-yellow-400 text-content-primary",
      purple: "bg-purple-400 text-content-primary",
      blue: "bg-blue-400 text-content-primary",
      sky: "bg-sky-400 text-content-primary",
      cyan: "bg-cyan-400 text-content-primary",
      teal: "bg-teal-400 text-content-primary",
      emerald: "bg-emerald-400 text-content-primary",
      green: "bg-green-400 text-content-primary",
      lime: "bg-lime-400 text-content-primary",
      amber: "bg-amber-400 text-content-primary",
      orange: "bg-orange-400 text-content-primary",
      red: "bg-red-400 text-content-primary",
      rose: "bg-rose-400 text-content-primary",
      pink: "bg-pink-400 text-content-primary",
      fuchsia: "bg-fuchsia-400 text-content-primary",
      indigo: "bg-indigo-400 text-content-primary",
      neutral: "bg-neutral-400 text-content-primary",
      white: "bg-white text-content-primary",
      navy: "bg-blue-950 text-content-light",
    },
  },
});

export type TagStylesProps = VariantProps<typeof tagStyles>;
